import React, { ReactNode } from 'react'
import css from './chartTooltip.module.scss'

export default function Tooltip({ label, value }: { label: ReactNode; value?: ReactNode }) {
  return (
    <div className={css.tooltip_wrapper}>
      {label}
      {value && <div className={css.value}>{value}</div>}
    </div>
  )
}
